import { styled } from '@mui/material/styles';
import { DataGridPro } from '@mui/x-data-grid-pro';

interface DataGridContainerProps {
  loading?: boolean;
  height?: string;
}

export const DataGridContainer = styled('div')<DataGridContainerProps>`
  position: relative;
  display: flex;
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  margin-top: 1.5vh;
`;

export const tableStyles = ({ height }: DataGridContainerProps) => ({
  position: 'relative' as const,
  paddingLeft: '1vw',
  paddingRight: '1vw',
  maxHeight: `${height}`,
  overflow: 'auto',
  backgroundColor: 'white',
  borderRadius: '1rem',
  borderColor: 'white',
});

export const NoRowsOverlayContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const DataGridProContainer = styled(DataGridPro)`
  & .MuiDataGrid-columnHeader {
    background-color: white;
  }
  &.MuiDataGrid-root .MuiDataGrid-cell:focus-within {
    outline: none !important;
  }
  &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    outline: none !important;
  }
  & .MuiDataGrid-cell {
    ${({ theme }) => theme.breakpoints.down('lg')} {
      font-size: 0.9rem;
    }
  }
  & .MuiDataGrid-columnHeaderTitle {
    ${({ theme }) => theme.breakpoints.down('lg')} {
      font-size: 0.9rem;
    }
  }
`;
